import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackOnboardingPlaceOfServiceView = (): void => {
  trackingService.trackEvent(
    'ONBOARDING',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      flow: 'onboarding',
      step: 'dados local atendimento',
      action: 'view',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingWhatsMyCepClick = (): void => {
  trackingService.trackEvent(
    'WHATS_MY_CEP',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: 'form',
      flow: 'onboarding',
      step: 'dados local atendimento',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingUploadImageClick = (): void => {
  trackingService.trackEvent(
    'UPLOAD_IMAGE',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: 'form',
      flow: 'onboarding',
      step: 'dados local atendimento',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingRemoveImageClick = (): void => {
  trackingService.trackEvent(
    'REMOVE',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: 'form',
      flow: 'onboarding',
      step: 'dados local atendimento',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingSwapImageClick = (): void => {
  trackingService.trackEvent(
    'SWAP_IMAGE',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: 'form',
      flow: 'onboarding',
      step: 'dados local atendimento',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingPlaceOfServiceContinueClick = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: 'form',
      flow: 'onboarding',
      step: 'dados local atendimento',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingImportDataView = (): void => {
  trackingService.trackEvent(
    'ONBOARDING',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      flow: 'onboarding',
      step: 'ajuda portabilidade',
      action: 'view',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingImportDataBackClick = (): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: '',
      flow: 'onboarding',
      step: 'ajuda portabilidade',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingPortabilityCheckboxClick = (): void => {
  trackingService.trackEvent(
    'PORTABILITY',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: 'form',
      flow: 'onboarding',
      step: 'ajuda portabilidade',
      element: 'checkbox',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingImportDataContinueClick = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: '',
      flow: 'onboarding',
      step: 'ajuda portabilidade',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingSuccessView = (): void => {
  trackingService.trackEvent(
    'ONBOARDING',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      flow: 'onboarding',
      step: 'final',
      action: 'view',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingSuccessBackClick = (): void => {
  trackingService.trackEvent(
    'BACK',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: '',
      flow: 'onboarding',
      step: 'final',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingSuccessAppStoreClick = (): void => {
  trackingService.trackEvent(
    'APP_STORE',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: '',
      flow: 'onboarding',
      step: 'final',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingSuccessGooglePlayClick = (): void => {
  trackingService.trackEvent(
    'GOOGLE_PLAY',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: '',
      flow: 'onboarding',
      step: 'final',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackOnboardingSuccessContinueClick = (): void => {
  trackingService.trackEvent(
    'CONTINUE',
    PRODUCT_NAME,
    {
      page: 'onboarding',
      placement: 'main',
      surface: '',
      flow: 'onboarding',
      step: 'final',
      element: 'button',
      action: 'click',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
